type AddressStreetInfoStandardVariantProps = {
  streetNumber: string;
  streetName: string;
  streetAdditional: string;
  city: string;
  postcode: string;
  countryName: string;
  hidePostCode?: boolean;
  isReversed?: boolean;
};

export const AddressStreetInfoStandardVariant = ({
  streetNumber = "",
  streetName = "",
  streetAdditional = "",
  city = "",
  postcode = "",
  countryName = "",
  isReversed,
  hidePostCode = false,
}: AddressStreetInfoStandardVariantProps) => {
  const postCodeText = !hidePostCode ? postcode : "";
  const addressData = isReversed
    ? `${streetNumber} ${streetName} ${streetAdditional}`
    : `${streetName} ${streetNumber} ${streetAdditional}`;

  const addressValues = [city, postCodeText, countryName];
  const showAddressInfoCity = addressValues.some(Boolean);
  const addressInfoCity = addressValues
    .reduce((acc, item) => {
      if (item) {
        acc = `${acc} ${item}`;
      }
      return acc;
    }, "")
    .replace(/\s\s+/g, " ")
    .trim();

  return (
    <>
      <div data-testid="AddressInfoStreet">{addressData}</div>
      {showAddressInfoCity && <div data-testid="AddressInfoCity">{addressInfoCity}</div>}
    </>
  );
};
